// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_de-b";
export var colorBlue = "_de-8";
export var colorDot = "_de-0";
export var colorDotLarge = "_de-2";
export var colorDotSmall = "_de-1";
export var colorGreen = "_de-7";
export var colorGrey = "_de-3";
export var colorOrange = "_de-5";
export var colorPink = "_de-a";
export var colorPurple = "_de-9";
export var colorRed = "_de-4";
export var colorYellow = "_de-6";